"use client";

import Link from "next/link";
import React, { useMemo, useEffect } from "react";
import { usePathname } from "next/navigation";
import { useAppStore } from "@/store/useAppStore";
import {
  authDesktopNavigationList,
  notAuthDesktopNavigationList,
} from "@/utils/desktopNavigation";

import { useAuth } from "@/hooks/useAuth";
import {
  authMobileNavigationList,
  notAuthMobileNavigationList,
} from "@/utils/mobileNavigation";

export const Navigation = () => {
  const { user } = useAuth();
  const pathname = usePathname();
  const { activeTab, setActiveTab } = useAppStore();

  const desktopNavigationList = useMemo(
    () => (user ? authDesktopNavigationList : notAuthDesktopNavigationList),
    [user]
  );

  const mobileNavigationList = useMemo(
    () => (user ? authMobileNavigationList : notAuthMobileNavigationList),
    [user]
  );

  useEffect(() => {
    const currentPath = pathname.slice(1);
    const currentTab = [...desktopNavigationList, ...mobileNavigationList].find(
      (tab) => tab.href === currentPath
    );

    if (currentTab && currentTab.id !== activeTab) {
      setActiveTab(currentTab.id);
    }
  }, [pathname, desktopNavigationList, activeTab, setActiveTab]);

  return (
    <>
      <nav className="desktop-nav flex items-center gap-6">
        {desktopNavigationList.map((tab) => (
          <Link
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            href={`/${tab.href}`}
            className={`text-sm transition-colors cursor-pointer text-nowrap ${
              activeTab === tab.id
                ? "text-white"
                : "text-[#808080] hover:text-white"
            }`}
          >
            {tab.label}
          </Link>
        ))}
      </nav>

      <div className="mobile-nav">
        <div className="flex justify-around items-center w-full px-4">
          {mobileNavigationList.map((tab) => (
            <Link
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              href={`/${tab.href}`}
              className={`flex flex-col items-center justify-center py-2 px-3 transition-colors ${
                activeTab === tab.id ? "text-white" : "text-[#808080]"
              }`}
            >
              <span className="text-xs font-medium">{tab.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};
